function Gallery(){
    this.arrows = true;
    this.middleTop = true;
    this.middleBottom = true;
}

Gallery.prototype.construct = function(){

    let that = this;

    this.overlay = $('<div class="gallery__overlay"></div>');

    $('body').prepend( this.overlay );

    that.markup();


};

Gallery.prototype.destroy = function(){

    let that = this;
    that.initTimeline.reverse();

};

Gallery.prototype.markup = function(){

    let that = this;

    this.close_label = $('.translate-js__btn-close').html();
    this.close = $('<span class="gallery__container__close"><span class="gallery__container__close__label">'+this.close_label+'</span><span class="gallery__container__close__icon link-icon"></span></span>');
    this.container = $('<div class="gallery__container"></div>');
    this.containerLeft = $('<div class="gallery__container__left"></div>');
    this.containerMiddle = $('<div class="gallery__container__middle"></div>');
    this.containerRight = $('<div class="gallery__container__right"></div>');

    this.containerMiddleTop = $('<div class="gallery__container__middle__top"></div>');
    this.containerMiddleCenter = $('<div class="gallery__container__middle__center"></div>');
    this.containerMiddleBottom = $('<div class="gallery__container__middle__bottom"></div>');

    this.navigationPrev = $('<div class="gallery__container__navigation gallery__container__navigation--prev"></div>');
    this.navigationNext = $('<div class="gallery__container__navigation gallery__container__navigation--next"></div>');

    $('body').prepend( this.container );
    this.container.append( this.containerLeft );
    this.container.append( this.containerMiddle );
    this.container.append( this.containerRight );

    if( this.middleTop ) {
        this.containerMiddle.append(this.containerMiddleTop);
    }
    if( this.middleBottom ) {
        this.containerMiddle.append(this.containerMiddleBottom);
    }
    this.containerMiddle.append( this.containerMiddleCenter );

    this.containerLeft.append( this.navigationPrev );

    this.container.append( this.close );
    this.containerRight.append( this.navigationNext );

    this.overlayTimeline = gsap.timeline({
        paused: true,
        onComplete: function() {
            $(window).trigger('overlayDone');
        },
        onReverseComplete: function(){
            gsap.to( that.overlay, 0.5, {
                scaleX: 0,
                onComplete: function(){
                    that.overlay.empty().remove();
                    that.container.empty().remove();
                    $(window).unbind('overlayDone').unbind('initDone');
                }
            });
        }
    });

    this.overlayTimeline.add(
        gsap.to( that.overlay, 0.5, {
            scaleX: 1
        })
    );

    this.overlayTimeline.play();

};

Gallery.prototype.initAnimation = function(){

    let that = this;

    this.initTimeline = gsap.timeline({
        paused: true,
        onComplete: function() {
            $(window).trigger('initDone');
            const linkItems = document.querySelectorAll(".gallery__container__navigation");
            linkItems.forEach(item => {
                item.addEventListener("mouseenter",  mouseAnimation.sliderMouseEnter.bind(mouseAnimation));
                item.addEventListener("mouseleave", mouseAnimation.mouseLeave.bind(mouseAnimation));
            });
            const closeItems = document.querySelectorAll(".gallery__container__close");
            closeItems.forEach(item => {
                item.addEventListener("mouseenter",  mouseAnimation.linkMouseEnter.bind(mouseAnimation));
                item.addEventListener("mouseleave", mouseAnimation.mouseLeave.bind(mouseAnimation));
            });
        },
        onReverseComplete: function(){
            that.overlayTimeline.reverse();
        }
    });

    if( this.arrows ) {
        this.initTimeline.addLabel("extern");
        this.initTimeline.add(
            gsap.to(that.containerLeft, 0.3, {
                x: 0
            }), "extern"
        );
        this.initTimeline.add(
            gsap.to(that.containerRight, 0.3, {
                x: 0
            }), "extern"
        );
    }

    this.initTimeline.addLabel("middle");
    if( this.middleTop ) {
        this.initTimeline.add(
            gsap.fromTo(that.containerMiddleTop, 0.3, {
                y: '-100%'
            }, {
                y: '0%'
            }), "middle"
        );
    }
    if( this.middleBottom ) {
        this.initTimeline.add(
            gsap.fromTo(that.containerMiddleBottom, 0.3, {
                y: '100%'
            }, {
                y: '0%'
            }), "middle"
        );
    }

    this.initTimeline.add(
        gsap.fromTo(that.containerMiddleCenter, 0.3, {
            opacity: 0
        }, {
            opacity: 1
        }), "middle"
    );

    this.initTimeline.add(
        gsap.fromTo(that.close, 0.3,{
            y: "-200%"
        }, {
            y: '0%'
        }), "middle"
    );

    this.initTimeline.play();

};
